import { Injectable } from "@angular/core";
import { Store } from "@ngxs/store";
import * as BeamlineStatusActions from './bl-status.action';
import { GeneralSignalRResponse } from "src/app/services/signal-r/general-signal-r-response";
import { SignalRService } from "src/app/services/signal-r/signal-r.service";
import { SignalRAction } from "src/app/services/signal-r/signalr-enums";
import { Channels } from "src/app/store/channels";

@Injectable({
  providedIn: 'root'
})
export class BeamlineStatusStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }
  initStore() {
    this.store.dispatch(new BeamlineStatusActions.BeamlineStatusRefresh());
  }

  initListeners() {
    this.signalRService.hubConnection?.on(Channels.BEAMLINE_STATUS, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new BeamlineStatusActions.BeamlineStatusCreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new BeamlineStatusActions.BeamlineStatusUpdate(data.id, data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new BeamlineStatusActions.BeamlineStatusDelete(data.id));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new BeamlineStatusActions.BeamlineStatusRefresh());
      }
    });

    this.signalRService.hubConnection?.on(Channels.BEAMLINE_RESTRICTIONS, () => {
      this.store.dispatch(new BeamlineStatusActions.BeamlineStatusRefresh());
    });
  }
}
